import gql from 'graphql-tag';
import React, {Fragment} from 'react';
import {Query} from 'react-apollo';
import {matchPath} from 'react-router-dom';
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import config from '../../config';
import {logout} from '../../utils/auth';
import Content from '../common/Content';
import DefaultNavigation, {getPages} from '../common/DefaultNavigation';
import Tab from '../common/tabs/Tab';
import TabBar from '../common/tabs/TabBar';
import Title from '../common/Title';
import Toolbar from '../common/Toolbar';
import AddFavoritePage from '../favorites/AddFavoritePage';
import FavoritesPage from '../favorites/FavoritesPage';
import ReportsPage from '../reports/ReportsPage';
import ToolbarButtons from './ToolbarButtons';

const pageInfos = [
  {slug: 'favorites/add/:type', component: AddFavoritePage},
  {label: 'Favoriten', slug: 'favorites', component: FavoritesPage},
  {label: 'Auswertungen', slug: 'reports', component: ReportsPage},
];

const companyQuery = gql`
  query company($input: CompanyQueryInput!) {
    company(input: $input) {
      id
      logo
    }
  }
`;

const Logo = styled.img`
  height: 45px !important;
  margin-right: ${({theme}) => theme.spacingHorizontal()};
`;

const HomePage = props => {
  if (!props.user) {
    logout();
    return null;
    // return <Redirect to={{pathname: '/login', state: {from: props.location}}} />;
  }
  const input = {id: props.company};
  const pages = getPages(props.match, pageInfos);
  return (
    <Fragment>
      <Toolbar
        renderLeftContent={() => (
          <Query query={companyQuery} variables={{input}}>
            {({loading, error, data}) => {
              if (loading) return null;
              if (error) return null;
              return <Logo src={data.company.logo ? `${config.imgUrl}${data.company.logo}` : null} />;
            }}
          </Query>
        )}
        renderCenterContent={() => <Title>Analyse Performance App</Title>}
        renderRightContent={() => <ToolbarButtons {...props} />}
      />
      <Content>
        <TabBar>
          {pages.map(
            ({label, path, url, slug}) =>
              label && (
                <Grid.Unit key={slug} size={1 / 6}>
                  <Tab selected={matchPath(props.location.pathname, {path})} onClick={() => props.history.push(url)}>
                    {label}
                  </Tab>
                </Grid.Unit>
              )
          )}
        </TabBar>
        <DefaultNavigation {...props} pages={pages} defaultPageIndex={1} />
      </Content>
    </Fragment>
  );
};

export default HomePage;
